import React, { useState, useEffect } from 'react';
import { Paper, Box, FormControl, InputLabel, Select, MenuItem } from '@mui/material';
import { useGlobal } from '../contexts/GlobalContext';
import FilterSortQuery from './FilterSortQuery';
import BoostQuery from './BoostQuery';
import SemanticSearchQuery from './SemanticSearchQuery';
import AIPromptQuery from './AIPromptQuery';
import ESQueryQuery from './ESQueryQuery';

const QueryModes = ({ source, sortOptions, strictFilterTypeOptions, boostFilterTypeOptions }) => {
  const { mergeCurrentContext } = useGlobal();
  const [queryMode, setQueryMode] = useState('');

  const queryModes = [
    { id: 'filter_sort', label: 'Filter and sort' },
    { id: 'boost', label: 'Boost' },
    { id: 'semantic', label: 'Semantic Search' },
    { id: 'ai_prompt', label: 'AI prompt' },
    { id: 'es_query', label: 'ES Query' }
  ];

  const handleQueryModeChange = (event) => {
    const newMode = event.target.value;
    setQueryMode(newMode);
    mergeCurrentContext({ queryBeingBuilt: undefined });
  };

  useEffect(() => {
    mergeCurrentContext({
      queryMode,
      sortOptions,
      strictFilterTypeOptions,
      boostFilterTypeOptions,
      source,
    });
  }, [queryMode, sortOptions, strictFilterTypeOptions, boostFilterTypeOptions, source, mergeCurrentContext]);

  const renderQueryModeComponent = () => {
    switch (queryMode) {
      case 'filter_sort':
        return (
          <FilterSortQuery
            sortOptions={sortOptions}
            filterTypeOptions={strictFilterTypeOptions}
            source={source}
          />
        );
      case 'boost':
        return (
          <BoostQuery
            filterTypeOptions={boostFilterTypeOptions}
            source={source}
          />
        );
      case 'semantic':
        return <SemanticSearchQuery />;
      case 'ai_prompt':
        return (
          <AIPromptQuery
            placeholderText="Find recent posts about machine learning with high engagement..."
          />
        );
      case 'es_query':
        return <ESQueryQuery />;
      default:
        return null;
    }
  };

  return (
    <Paper elevation={2} sx={{ p: 2, display: 'flex', flexDirection: 'column' }}>
      <Box sx={{ mt: 2 }}>
        <FormControl fullWidth>
          <InputLabel id="query-mode-label">Select Query Mode</InputLabel>
          <Select
            labelId="query-mode-label"
            id="query-mode-select"
            value={queryMode}
            label="Select Query Mode"
            onChange={handleQueryModeChange}
          >
            {queryModes.map((mode) => (
              <MenuItem key={mode.id} value={mode.id}>
                {mode.label}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Box>
      
      {/* Render the selected query mode component */}
      {queryMode && (
        <Box sx={{ mt: 3, flex: 1, minHeight: 0 }}>
          {renderQueryModeComponent()}
        </Box>
      )}
    </Paper>
  );
};

export default QueryModes;
